import { render, staticRenderFns } from "./auth-switcher.vue?vue&type=template&id=44783bde&scoped=true"
import script from "./auth-switcher.vue?vue&type=script&lang=js"
export * from "./auth-switcher.vue?vue&type=script&lang=js"
import style0 from "./auth-switcher.vue?vue&type=style&index=0&id=44783bde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44783bde",
  null
  
)

export default component.exports